import React, { Component } from 'react';
import { NavBar, Icon } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import ProfileView from '../components/ProfileView';
import QRCode from 'qrcode.react';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/OperatorCouponTicket.css';
import CommonUtils from '../utils/CommonUtils';
import Blank from '../components/Blank';
import iconCoupon from '../medias/coupon.svg';

const history = require("history").createHashHistory()

class OperatorCouponTicket extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            refreshing: false,
            couponActivity: {},
            couponTicket: {},
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.activityId = CommonUtils.resolveSearchParam(this.props.location, 'activityId')
        this.organizationId = CommonUtils.resolveSearchParam(this.props.location, 'organizationId')
        this.loadDeviceTypes()
        this.loadCouponActivity(() => {
            this.loadCouponTicket()
        })
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadCouponActivity = (callback) => {
        this.setState({
            loading: true
        })
        DataFetcher.operatorActivityDetail({
            activityId: this.activityId
        }, {
            success: (resp) => {
                this.setState({
                    couponActivity: resp.data
                }, () => {
                    callback&&callback()
                })
            },
            completed: () => {
                this.setState({
                    loading: false
                })
            }
        })
    }

    loadCouponTicket = () => {
        this.setState({
            refreshing: true
        })
        DataFetcher.operatorCouponTicket({
            activityId: this.activityId,
            organizationId: this.organizationId
        }, {
            success: (resp) => {
                this.setState({
                    couponTicket: resp.data
                })
            },
            completed: () => {
                this.setState({
                    refreshing: false
                })
            }
        })
    }

    handleRefreshClick = () => {
        this.loadCouponTicket()
    }
    
    generateHeaderView() {
        const { couponActivity } = this.state;
        return (
            <div className="section-header">
                <div className="container-left">
                    <div className="fl wrapper-avatar">
                        <img src={iconCoupon} alt=""/>
                    </div>
                    <div className="fl wrapper-basic">
                        <div className="name word-ellipsis">{couponActivity.name?couponActivity.name:'优惠活动'}</div>
                        <div className="brand word-ellipsis">用微信扫描二维码领取优惠券</div>
                    </div>
                </div>
            </div>
        )
    }

    generateProfileView() {
        const { couponActivity } = this.state;
        if(!couponActivity || !couponActivity.couponType) {
            return
        }

        let data = []
        data.push({label: '剩余数量', value: `${couponActivity.initCount}/${couponActivity.quantity}`})
        if(couponActivity.couponType === 'GAME_MINUTES') {
            data.push({label: '游戏时间', value: CommonUtils.readableGameMinutes(couponActivity.gameMinutes)})
        } else if(couponActivity.couponType === 'PACKET_DISCOUNT') {
            data.push({label: '套餐折扣', value: couponActivity.discount + '%'})
        } else {
            data.push({label: '已领数量', value: couponActivity.toExchangeCount + couponActivity.exchangedCount})
        }
        data.push({label: '用户限领', value: `${couponActivity.limitPerUser?couponActivity.limitPerUser:'不限'}`}) 

        return <ProfileView data={data}/>
    }

    doGenerateDetailRowForDiscount = () => {
        const { couponActivity } = this.state
        if(!couponActivity || !couponActivity.id) {
            return
        }

        if(couponActivity.couponType !== 'PACKET_DISCOUNT') {
            return
        }

        let discountScope = '不限'
        if(couponActivity.bottomAmount && couponActivity.topAmount) {
            discountScope = `￥${couponActivity.bottomAmount}  ~  ￥${couponActivity.topAmount}`
        } else if(couponActivity.bottomAmount) {
            discountScope = `最低￥${couponActivity.bottomAmount}`
        } else if(couponActivity.topAmount) {
            discountScope = `最高￥${couponActivity.topAmount}`
        }

        return (
            <div className='detail-row'>
                <span className='detail-label'>适用套餐：</span>
                <span className='detail-value'>{discountScope}</span>
            </div>
        )
    }

    generateDetailView = () => {
        const { couponActivity } = this.state
        if(!couponActivity || !couponActivity.id) {
            return 
        }

        return (
            <div className='section-detail'>
                {this.doGenerateDetailRowForDiscount()}
                <div className='detail-row'>
                    <span className='detail-label'>设备类型：</span>
                    <span className='detail-value'>{CommonUtils.resolveDictText(couponActivity.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                </div>
                <div className='detail-row'>
                    <span className='detail-label'>适用门店：</span>
                    <span className='detail-value'>{couponActivity.siteNames?couponActivity.siteNames.join(','):'全国门店'}</span>
                </div>
                <div className='detail-row'>
                    <span className='detail-label'>活动时间：</span>
                    <span className='detail-value'>{CommonUtils.shortenDateTime(couponActivity.startTime)}  ~  {CommonUtils.shortenDateTime(couponActivity.endTime)}</span>
                </div>
                <div className='detail-row'>
                    <span className='detail-label'>活动描述：</span>
                    <span className='detail-value'>{couponActivity.description}</span>
                </div>
            </div>
        )
    }

    generateQRCodeView = () => {
        const { couponActivity, couponTicket, refreshing } = this.state
        if(couponActivity.progress === 'PREPARING') {
            return <TipPlaceholder firstTip="活动未开始"/>
        }

        if(couponActivity.progress === 'FINISHED') {
            return <TipPlaceholder firstTip="活动已结束"/>
        }

        if(!couponTicket || !couponTicket.ticketQRCode) {
            return <TipPlaceholder firstTip="无效活动"/>
        }

        return (
            <div className='section-qrcode'>
                <div className='qrcode-content'>
                    <QRCode value={couponTicket.ticketQRCode} size={180}/>
                </div>
                <div className='qrcode-tip'>{refreshing ? '加载中...' : '动态券码'}</div>
            </div>
        )
    }

    doRenderView = () => {
        const { loading } = this.state

        if(loading) {
            return <LoadingPlaceholder/>
        }

        return (
            <div className='wrapper-content'>
                {this.generateHeaderView()}
                {this.generateProfileView()}
                <Blank/>
                {this.generateDetailView()}
                {this.generateQRCodeView()}
            </div>
        )
    }

    render() {
        return (
            <div className='page-operator-coupon-ticket'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={<i className='iconfont icon-shuaxin' style={{color:'black', fontSize: 22}} onClick={this.handleRefreshClick}></i>}
                >
                    动态券码
                </NavBar>
                {this.doRenderView()}
            </div>
        )
    }
}

export default createForm()(OperatorCouponTicket);


// WEBPACK FOOTER //
// ./src/modules/OperatorCouponTicket.js